import { Redirect } from "expo-router";
import { useTenant } from "@src/features/tenants";
import { useSelectedSiteStore } from "@src/stores/selected-site-store";

export default function VehiclesRedirect() {
  const { selectedTenant } = useTenant();
  const selectedSiteId = useSelectedSiteStore((s) => s.selectedSiteId);

  if (!selectedTenant?.id) return null;

  const path =
    selectedSiteId ?
      `/tenants/${selectedTenant.id}/vehicles?siteIds=${selectedSiteId}`
    : `/tenants/${selectedTenant.id}/vehicles`;

  return <Redirect href={path as never} />;
}
